import { ChangeEvent, useState } from "react";

import { debounce } from "@/utils/debounce";

function useDebounceSearch() {
  const [keyword, setKeyword] = useState<string>("");

  const getDebounce = debounce((data) => {
    setKeyword(data);
  }, 500);

  const onChangeSearch = (event: ChangeEvent<HTMLInputElement>) => {
    getDebounce(event.target.value);
  };

  return { keyword, onChangeSearch };
}

export default useDebounceSearch;
